import { createSelector } from 'reselect';
import { experienceSelector } from 'selectors/testTarget/offers/reorderFulfillmentOptions/experience/experienceSelector';
import { isTestTargetReadySelector } from 'viewModel/selectors/testTarget/isTestTargetReadySelector';
import { REORDER_FULFILLMENT_OPTIONS_EXPERIENCE } from 'constants/TestTarget';

const showReorderFulfillmentOptionsSelector = createSelector(isTestTargetReadySelector, experienceSelector, (testReady, experience) => ({
    challengerOne: testReady && experience === REORDER_FULFILLMENT_OPTIONS_EXPERIENCE.CHALLENGER_ONE,
    challengerTwo: testReady && experience === REORDER_FULFILLMENT_OPTIONS_EXPERIENCE.CHALLENGER_TWO
}));

export { showReorderFulfillmentOptionsSelector };
